module.exports = __webpack_public_path__ + "img/y.83f06215.jpg";